export class Timeouts {
    constructor() {
        this.inner = new Set();
    }
    add(t) {
        if (t === undefined) {
            return;
        }
        t = +t;
        if (this.inner.has(t)) {
            clearTimeout(t);
        }
        this.inner.add(t);
        return t;
    }
    remove(t) {
        if (t === undefined) {
            return;
        }
        t = +t;
        clearTimeout(t);
        this.inner.delete(t);
    }
    removeAll() {
        this.inner.forEach(clearTimeout);
        this.inner.clear();
    }
}
//# sourceMappingURL=timeouts.js.map